<template>
  <form>
    <h4 class="card-title">{{$t('medium_grant.submit__1_applicant_declaration')}}</h4>
    <div class="row">
      <div class="col-lg-12">
        <p class="white-space-pre">{{$t('medium_grant.submit__1_applicant_declaration_text')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <div class="mt-5"></div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="submit.orgName"
            v-model="GrantForm.model.submit.orgName"
            :error="getError('submit.orgName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.submit__1_orgname')"
            :label="$t('medium_grant.submit__1_orgname')"
            :placeholder="$t('medium_grant.submit__1_orgname')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="submit.address"
            v-model="GrantForm.model.submit.address"
            :error="getError('submit.address')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.submit__1_address')"
            :label="$t('medium_grant.submit__1_address')"
            :placeholder="$t('medium_grant.submit__1_address')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="submit.contactDetails"
            v-model="GrantForm.model.submit.contactDetails"
            :error="getError('submit.contactDetails')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.submit__1_contact_details')"
            :label="$t('medium_grant.submit__1_contact_details')"
            :placeholder="$t('medium_grant.submit__1_contact_details')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="submit.position"
            v-model="GrantForm.model.submit.position"
            :error="getError('submit.position')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.submit__1_position')"
            :label="$t('medium_grant.submit__1_position')"
            :placeholder="$t('medium_grant.submit__1_position')"
          >
          </textarea>
        </div>
        <div>
          <label>{{$t('medium_grant.submit__1_signature')}}</label>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.submit.signatureAndStamp" :file-data="GrantForm.files.submit.signatureAndStamp" :is-editable="GrantForm.isEditable" section="submit.signatureAndStamp"></upload-file>
        </div>
        <base-input
          name="submit.date"
          v-model="GrantForm.model.submit.date"
          :error="getError('submit.date')"
          v-validate="'required'"
          :data-vv-as="$t('medium_grant.submit__1_date')"
          :placeholder="$t('medium_grant.submit__1_date')"
        >
          <label>{{$t('medium_grant.submit__1_date')}}</label>
          <el-date-picker
            type="date"
            v-model="submitDate"
            :placeholder="$t('medium_grant.submit__1_date')"
          >
          </el-date-picker>
        </base-input>
      </div>
    </div>
  </form>
</template>
<script>
  import {DatePicker} from 'element-ui';
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        submitDate: '',
        moment: ''
      }
    },
    beforeMount() {
      this.moment = require('moment');

      if (GrantForm.model.submit.date !== undefined) {
        this.submitDate = GrantForm.model.submit.date;
      }
    },
    components: {
      [DatePicker.name]: DatePicker
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    },
    watch: {
      submitDate(newValue, oldValue) {
        GrantForm.model.submit.date = this.moment(newValue).format('YYYY-MM-DD');
      }
    }
  }
</script>
<style scoped>
  p.white-space-pre {
    white-space: pre-wrap;
  }
</style>